/**
 * @generated SignedSource<<161f1ceaf83a6d387d286295badaf85f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RequestStatus = "FAILED" | "PROCESSED" | "PROCESSING" | "%future added value";
export type UpdateUserInput = {
  displayName: string;
};
export type ManageProfileAccordion_ManageDisplayNameRowMutation$variables = {
  input: UpdateUserInput;
};
export type ManageProfileAccordion_ManageDisplayNameRowMutation$data = {
  readonly UpdateUser: {
    readonly errors: ReadonlyArray<{
      readonly code: string;
      readonly message: string;
    }> | null;
    readonly partitionKey: string;
    readonly request: {
      readonly correlationId: any;
      readonly status: RequestStatus;
    };
    readonly userState: {
      readonly displayName: string;
    } | null;
    readonly viewer: {
      readonly displayName: string;
    } | null;
  };
};
export type ManageProfileAccordion_ManageDisplayNameRowMutation = {
  response: ManageProfileAccordion_ManageDisplayNameRowMutation$data;
  variables: ManageProfileAccordion_ManageDisplayNameRowMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "partitionKey",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "Request",
  "kind": "LinkedField",
  "name": "request",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "correlationId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v7 = [
  (v6/*: any*/)
],
v8 = [
  (v6/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ManageProfileAccordion_ManageDisplayNameRowMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UserPayload",
        "kind": "LinkedField",
        "name": "UpdateUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserProfileViewer",
            "kind": "LinkedField",
            "name": "userState",
            "plural": false,
            "selections": (v7/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserProfileViewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": (v7/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ManageProfileAccordion_ManageDisplayNameRowMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UserPayload",
        "kind": "LinkedField",
        "name": "UpdateUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserProfileViewer",
            "kind": "LinkedField",
            "name": "userState",
            "plural": false,
            "selections": (v8/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserProfileViewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": (v8/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "384a9592379f0bd99233fddd79092add",
    "id": null,
    "metadata": {},
    "name": "ManageProfileAccordion_ManageDisplayNameRowMutation",
    "operationKind": "mutation",
    "text": "mutation ManageProfileAccordion_ManageDisplayNameRowMutation(\n  $input: UpdateUserInput!\n) {\n  UpdateUser(input: $input) {\n    errors {\n      __typename\n      code\n      message\n    }\n    partitionKey\n    request {\n      correlationId\n      status\n    }\n    userState {\n      displayName\n      id\n    }\n    viewer {\n      displayName\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d365bbdaca463fec6a0ef70e74cb769a";

export default node;
